import React, { useContext } from 'react'
import styled from 'styled-components'
import { CreationToolsContext } from '../../manager'
import CreationToolGradient from '../../types/gradient'
import CreationToolOutputType from '../../types/output-type'
import CreationToolStatus from '../../types/status'
import CreationToolWelcomeButton from '../../types/welcome-button'
import { GradientButton } from '../buttons'
import { CreationToolUploadContext } from './manager'

const Icon = styled(CreationToolWelcomeButton.icon(CreationToolWelcomeButton.UploadAddMore))`
    height: 16px;
    margin-right: 5px;
`
const AddMoreFiles = styled(GradientButton)`
    padding: 0 20px;
`

const AddMoreButton = ({ isProcessing }: { isProcessing: boolean }) => {
    const { outputType } = useContext(CreationToolsContext)
    const { status } = useContext(CreationToolUploadContext)
    return (
        <AddMoreFiles
            disabled={isProcessing || status === CreationToolStatus.Uploading}
            colors={CreationToolGradient.colors(CreationToolGradient.IndigoPurple)}
        >
            <Icon />
            <div>{`Add More ${CreationToolOutputType.title(outputType)}s`}</div>
        </AddMoreFiles>
    )
}
export default AddMoreButton
